var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import EncryptUtils from '@popup/steem/utils/encrypt.utils';
const login = (password) => __awaiter(void 0, void 0, void 0, function* () {
    // // console.log('[MkUtils] login called with password:', password);
    try {
        const storedMk = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
        // // console.log('[MkUtils] Stored MK from SessionStorage:', storedMk);
        if (!storedMk) {
            // // console.log('[MkUtils] No stored MK found');
            return false;
        }
        //    const isMatch = storedMk === password.trim();
        const pass = password.trim();
        const hashedPass = EncryptUtils.hashPassword(pass);
        //    // console.log('[MkUtils] Password: ', hashedPass);
        //	const destringMK = decryptedMk.toString(CryptoJS.enc.Utf8);
        //    // // console.log('[MkUtils] Password MK string:', destringMK);
        const isMatch = storedMk === hashedPass;
        //    // // console.log('[MkUtils] Password match:', isMatch);
        if (isMatch) {
            // // console.log('[MkUtils] Unlocking app');
            LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.IS_LOCKED, 'false');
        }
        return isMatch;
    }
    catch (error) {
        console.error('[MkUtils] Error in login:', error);
        return false;
    }
});
//const getMkFromLocalStorage = () => {
//  const mk = LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
//  return mk;
//};
const getMkFromLocalStorage = () => __awaiter(void 0, void 0, void 0, function* () {
    const mk = LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    return mk;
});
const saveMkInLocalStorage = (mk) => {
    // // console.log('[MkUtils] saveMkInLocalStorage called with mk:', mk);
    LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.__MK, EncryptUtils.hashPassword(mk));
    //  LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.__MK, EncryptUtils.encrypt(mk, mk));
    LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.IS_LOCKED, 'false');
};
const lock = () => {
    // // console.log('[MkUtils] lock called, setting IS_LOCKED to true');
    LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.IS_LOCKED, 'true');
};
const isPasswordValid = (password) => {
    return (password.length >= 16 ||
        (password.length >= 8 &&
            password.match(/.*[a-z].*/) &&
            password.match(/.*[A-Z].*/) &&
            password.match(/.*[0-9].*/)));
};
const isLocked = () => __awaiter(void 0, void 0, void 0, function* () {
    // // console.log('[MkUtils] isLocked called');
    const isLocked = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.IS_LOCKED);
    // // console.log('[MkUtils] isLocked result:', isLocked);
    return isLocked === 'true';
});
const MkUtils = {
    login,
    getMkFromLocalStorage,
    saveMkInLocalStorage,
    lock,
    isLocked,
    isPasswordValid,
};
export default MkUtils;
